import { useState } from 'react';

import '../../resources/css/management-panel.css';
import { useSetContentMutation } from '../../store';

export default function ControlPanel({ index, partition }) {

    const [control, setControl] = useState('');
    const [updateData] = useSetContentMutation();

    const controlsCollection = ['...', 'Cascade', 'Contacts', 'PhotoBlog', 'MagicContent', 'Map', 'NewsBlog' ];

    const options = controlsCollection.map((item) => {
        return <option key={item} value={item}>{item}</option>
    });

    const handleChange = (e) => {
        setControl(e.target.value);
    }

    const handleClick = () => {

        if (!control) { return; }

        const newComponent = {
            partition,
            order: index,
            key: `${partition}-${control}-${crypto.randomUUID()}`,
            controlType: control,
            content: {}
        };

        updateData(newComponent);

        setControl('');
    };

    return (
        <div>
            <div className="management-panel">
                {options && <select onChange={handleChange}>{options}</select>}
                <span onClick={handleClick}>
                    <i className="fa fa-plus-square" aria-hidden="true"></i>
                </span>
            </div>

        </div>
    );
}